"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AchievementsBar = void 0;
var GameVars_1 = require("../../GameVars");
var AchievementsBar = /** @class */ (function (_super) {
    __extends(AchievementsBar, _super);
    function AchievementsBar(scene, i) {
        var _this = _super.call(this, scene) || this;
        var whiteFrame = new Phaser.GameObjects.Graphics(_this.scene);
        whiteFrame.fillStyle(0xAD60F8);
        whiteFrame.fillRoundedRect(-AchievementsBar.BAR_WIDTH / 2, -AchievementsBar.BAR_HEIGHT / 2, AchievementsBar.BAR_WIDTH, AchievementsBar.BAR_HEIGHT, AchievementsBar.BAR_HEIGHT / 2);
        _this.add(whiteFrame);
        var lilacFrame = new Phaser.GameObjects.Graphics(_this.scene);
        lilacFrame.fillStyle(0x6330B0);
        lilacFrame.fillRoundedRect(-(AchievementsBar.BAR_WIDTH - 6) / 2, -(AchievementsBar.BAR_HEIGHT - 6) / 2, AchievementsBar.BAR_WIDTH - 6, AchievementsBar.BAR_HEIGHT - 6, (AchievementsBar.BAR_HEIGHT - 3) / 2);
        _this.add(lilacFrame);
        var leftTip = new Phaser.GameObjects.Graphics(_this.scene);
        leftTip.fillStyle(0x38DD00);
        leftTip.fillCircle(0, 0, (AchievementsBar.BAR_HEIGHT - 6) / 2);
        leftTip.x = -(AchievementsBar.BAR_WIDTH - 6) / 2 + (AchievementsBar.BAR_HEIGHT - 3) / 2 - 2;
        _this.add(leftTip);
        _this.bar = new Phaser.GameObjects.Graphics(_this.scene);
        _this.add(_this.bar);
        _this.barTip = new Phaser.GameObjects.Graphics(_this.scene);
        _this.add(_this.barTip);
        _this.progressLabel = new Phaser.GameObjects.Text(_this.scene, 0, -2, "", { fontFamily: "Baloo", fontSize: "28px", color: "#FFFD2D" });
        _this.progressLabel.setOrigin(.5);
        _this.progressLabel.setStroke("#126800", 5);
        _this.add(_this.progressLabel);
        return _this;
    }
    AchievementsBar.prototype.reset = function (value, treshold) {
        this.setBarLength(Math.min(value / treshold, 1));
        this.progressLabel.text = GameVars_1.GameVars.formatNumber(value) + "/" + GameVars_1.GameVars.formatNumber(treshold);
    };
    AchievementsBar.prototype.setBarLength = function (percentage) {
        var totalLength = -AchievementsBar.BAR_WIDTH + 6 + AchievementsBar.BAR_HEIGHT - 3;
        var px = -(AchievementsBar.BAR_WIDTH - 6) / 2 + (AchievementsBar.BAR_HEIGHT - 3) / 2 - totalLength * percentage;
        this.bar.clear();
        this.bar.fillStyle(0x38DD00);
        this.bar.fillRect(-(AchievementsBar.BAR_WIDTH - 6) / 2 + (AchievementsBar.BAR_HEIGHT - 3) / 2, -(AchievementsBar.BAR_HEIGHT - 6) / 2, (AchievementsBar.BAR_WIDTH - AchievementsBar.BAR_HEIGHT - 3) * percentage, AchievementsBar.BAR_HEIGHT - 6);
        this.barTip.clear();
        this.barTip.fillStyle(0x38DD00);
        this.barTip.fillCircle(0, 0, (AchievementsBar.BAR_HEIGHT - 6) / 2);
        this.barTip.x = px + 2;
    };
    AchievementsBar.BAR_WIDTH = 196;
    AchievementsBar.BAR_HEIGHT = 24;
    return AchievementsBar;
}(Phaser.GameObjects.Container));
exports.AchievementsBar = AchievementsBar;
